import styled, { css } from 'styled-components';
import themeColors from '../../assets/styles/themeColors';

const thumbCss = css`
  -webkit-appearance: none;
  width: 100%;
  height: 20px;
  width: 20px;
  border: 3px solid ${themeColors.colorBorderSecondary};
  border-radius: 50%;
  background: ${themeColors.colorBackgroundPrimary};
`;

const thumbTrackCss = css`
  -webkit-appearance: none;
  box-shadow: none;
  border: none;
  background: transparent;
`;

export const Range = styled.input.attrs((props) => ({
  ...props,
  type: 'range',
}))`
  -webkit-appearance: none;
  height: 6px;
  border-radius: 3px;
  background: grey;

  &::-webkit-slider-thumb {
    ${thumbCss};
  }

  &::-moz-range-thumb {
    ${thumbCss};
  }

  &::-webkit-slider-runnable-track {
    ${thumbTrackCss};
  }

  &::-moz-range-track {
    ${thumbTrackCss};
  }
`;
